import React from 'react';

import type { FormStepId } from 'shared/config/formStepId';

import { AuthenticationEsia, useIsShowAuthenticationEsia } from 'features/AuthenticationEsia';
import { EsiaConsentBanner, useShouldShowEsiaConsentBanner } from 'features/EsiaConsentBanner';

type EsiaProps = {
  formId: FormStepId;
};

export const Esia = ({ formId }: EsiaProps) => {
  const checkIsShowEsiaLoginBlock = useIsShowAuthenticationEsia();
  const isShowEsiaBlock = checkIsShowEsiaLoginBlock(formId);
  const shouldShowConsentBanner = useShouldShowEsiaConsentBanner(formId);

  if (shouldShowConsentBanner) {
    return <EsiaConsentBanner />;
  }

  if (isShowEsiaBlock) {
    return <AuthenticationEsia step={formId} />;
  }

  return null;
};
